import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TrialExpiredModal.css';

interface TrialExpiredModalProps {
  onClose: () => void;
}

const TrialExpiredModal: React.FC<TrialExpiredModalProps> = ({ onClose }) => {
  const navigate = useNavigate();

  const handleViewPlans = () => {
    navigate('/plans');
    onClose();
  };

  return (
    <div className="trial-modal-overlay">
      <div className="trial-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="trial-modal-icon">
          <i className="bi bi-exclamation-triangle-fill"></i>
        </div>
        
        <h2 className="trial-modal-title">Your trial has expired</h2>
        
        <p className="trial-modal-message">
          Your 7-day trial period has ended. To continue accessing DISGENET features, please choose a plan that fits your needs.
        </p>
        
        <div className="trial-modal-actions">
          <button 
            className="btn-gradient-pink trial-modal-btn-primary" 
            onClick={handleViewPlans}
          >
            View Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpiredModal;
